import * as angular from 'angular';

export default class Utils {
  truncate(value: number, decimals: number = 2): number {
    // Guard against junk
    if (!angular.isNumber(value)) return undefined;

    const strval: string = value.toString();
    const index: number = strval.indexOf('.');

    return index >= 0 ? parseFloat(strval.slice(0, index + decimals + 1)) : value;
  }
}

angular.module('ciApp.services').service('Utils', Utils);



// WEBPACK FOOTER //
// ./common/services/utils.service.ts